<kal-table [dataSource]="parameters" [columns]="columns">

    <tr *kalHeaderRowDef kal-header-row></tr>

    <td *kalBodyCell="'IdCritere' let row">
        {{ (row.IdCritere | findInListById: criteriaList)?.Libelle }}
    </td>

    <td *kalBodyCell="'IdOperateur' let row">
        {{ (row.IdOperateur | findInListById: operatorsList)?.Libelle }}
    </td>

    <td *kalBodyCell="'Valeur' let row">
        <app-shared-advanced-rule-criterion-value-detail
            [value]="row.Valeur"
            [criterion]="row.IdCritere | findCriterionById: criteriaList">
        </app-shared-advanced-rule-criterion-value-detail>
    </td>

</kal-table>
